import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import './style.css';

export default class PeopleSearcher extends Component {
  constructor() {
    super();
    const queryStrings = queryString.parse(location.search);
    this.state = {
      keyword: decodeURI(queryStrings.keyword ? queryStrings.keyword : ''),
    };
  }

  componentWillMount() {
    const path = location.pathname;
    if (path !== '/tube/peoplesearch') {
      return this.setState({ keyword: '' });
    }
  }

  render() {
    return (
      <form action="/peoplesearch">
        <div className="header-search">
          <label className="search__label" name="search__input"><i className="fa fa-search"></i></label>
          <input
            id="search__input"
            className=" search__input form-control"
            value={this.state.keyword}
            type="text"
            placeholder="People Search"
            name="keyword"
            onKeyPress={(e) => {
              if (e.charCode === 13) {
                e.preventDefault();
                const queryStrings = queryString.parse(location.search);
                if (this.state.keyword !== queryStrings.keyword && location.pathname === '/tube/peoplesearch') {
                  return this.props.history.pushState(null, `/tube/peoplesearch?keyword=${this.state.keyword.trim()}`);
                } else if (location.pathname !== '/tube/peoplesearch') {
                  location.href = `/tube/peoplesearch?keyword=${this.state.keyword.trim()}`;
                }
              }
            }}
            onChange={(e) => {
              this.setState({
                keyword: e.target.value,
              });
            }}
          />
        </div>
      </form>
    );
  }
}
const propTypes = {
  history: PropTypes.object,
};
PeopleSearcher.propTypes = propTypes;



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Header/components/PeopleSearcher/index.js
 **/